import { useState } from 'react';
import { api } from '../utils/api';

interface UseImageUploadOptions {
  onSuccess?: () => void;
  onError?: (error: string) => void;
}

export const useImageUpload = (options: UseImageUploadOptions = {}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const uploadProfilePicture = async (imageData: string | null) => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.post('/users/profile-picture', {
        profile_picture: imageData
      });

      options.onSuccess?.();
      return response.data;
    } catch (err: any) {
      const errorMessage = err.response?.data?.detail || 'Failed to upload profile picture';
      setError(errorMessage);
      options.onError?.(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const uploadEventImages = async (eventId: string, images: { 
    image_1?: string | null;
    image_2?: string | null; 
    image_3?: string | null;
  }) => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.post(`/events/${eventId}/images`, images);

      options.onSuccess?.();
      return response.data;
    } catch (err: any) {
      const errorMessage = err.response?.data?.detail || 'Failed to upload event images';
      setError(errorMessage);
      options.onError?.(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    uploadProfilePicture,
    uploadEventImages,
    clearError: () => setError(null)
  };
};
